<template>
    <div>
        <h1 class="mb-8 font-bold text-3xl">
            <inertia-link class="text-indigo-400 hover:text-indigo-600"
                :href="route('tecnicos')">Técnicos</inertia-link>
            <span class="text-indigo-400 font-medium">/</span> Editar
        </h1>

        <div class="bg-white rounded-md shadow overflow-hidden max-w-4xl">
            <form @submit.prevent="update">
                <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
                    <text-input v-model="form.nombre" :error="form.errors.nombre" class="pr-6 pb-8 w-full lg:w-1/2"
                        label="Nombre" required />

                    <text-input v-model="form.telefono" :error="form.errors.telefono" class="pr-6 pb-8 w-full lg:w-1/2"
                        label="Teléfono" />

                    <text-input v-model="form.email" :error="form.errors.email" class="pr-6 pb-8 w-full lg:w-1/2"
                        label="Email" />

                    <text-input v-model="form.especialidad" :error="form.errors.especialidad"
                        class="pr-6 pb-8 w-full lg:w-1/2" label="Especialidad" />

                    <select-input v-model="form.estado" :error="form.errors.estado" class="pr-6 pb-8 w-full lg:w-1/2"
                        label="Estado" required>
                        <option value="ACTIVO">ACTIVO</option>
                        <option value="INACTIVO">INACTIVO</option>
                    </select-input>

                    <text-input v-model="form.observaciones" :error="form.errors.observaciones" class="pr-6 pb-8 w-full"
                        label="Observaciones" />
                </div>

                <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
                    <loading-button :loading="form.processing" class="btn-indigo" type="submit">
                        Actualizar Técnico
                    </loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
    metaInfo: { title: 'Editar Técnico' },
    layout: Layout,
    components: { TextInput, SelectInput, LoadingButton },
    props: {
        tecnico: Object,
    },
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                nombre: this.tecnico.nombre || null,
                cedula: this.tecnico.cedula || null,
                telefono: this.tecnico.telefono || null,
                email: this.tecnico.email || null,
                especialidad: this.tecnico.especialidad || null,
                estado: this.tecnico.estado || 'ACTIVO',
                observaciones: this.tecnico.observaciones || null,
            }),
        }
    },
    methods: {
        update() {
            this.form.put(this.route('tecnicos.update', { tecnico: this.tecnico.id }))
        },
    },
}
</script>